var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// @ts-nocheck
import Events from './events';
import { baseInfo, interactive, report } from './native/index';
import webMethods from './web/index';
import { Expose } from './components/index';
import { renderDebugView } from './statView';
const IS_IN_APP = typeof grounds !== 'undefined';
const externalCallHandler = (name, args) => {
    if (webMethods[name]) {
        return webMethods[name](...args);
    }
    console.log(`Grounds：在外部环境调用了客户端方法：${name}()`);
    return new Proxy({}, {
        get: function (target, prop, receiver) {
            if (typeof prop === 'symbol' || prop === 'toString' || prop === 'valueOf') {
                return () => Grounds.__mock_value__ || null;
            }
            else {
                return externalCallHandler.bind(null, `${name}().${prop}`);
            }
        }
    });
};
const addMethods = methods => {
    return target => {
        Object.keys(methods).forEach(item => {
            target.prototype[item] = (...args) => {
                if (!IS_IN_APP) {
                    return externalCallHandler(item, args);
                }
                else {
                    return methods[item](...args);
                }
            };
        });
    };
};
let Grounds = class Grounds {
    constructor() {
        // 监听webview被挂起（一般是app被放到后台的情况下）
        this.on('exit', () => {
            console.log('exit');
            this.trigger('exit');
        });
        // 监听webview被激活
        this.on('active', () => {
            console.log('active');
            this.trigger('active');
        });
    }
};
Grounds = __decorate([
    addMethods(report),
    addMethods(baseInfo),
    addMethods(interactive)
], Grounds);
Events.mixTo(Grounds);
Grounds.prototype.Expose = Expose;
Grounds.prototype.mock = function (val) {
    if (IS_IN_APP)
        return this;
    Grounds.__mock_value__ = val;
    return externalCallHandler('mock');
};
const GroundsInstance = new Grounds();
renderDebugView(GroundsInstance);
export default GroundsInstance;
